import * as Blockly from 'blockly/core'

export function registerLoopBlocks() {
  Blockly.common.defineBlocksWithJsonArray([
    {
      type: 'loop_repeat',
      message0: '🔁 ulang %1 kali',
      args0: [{ type: 'field_number', name: 'TIMES', value: 10, min: 1, max: 100 }],
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 20,
      tooltip: 'Ulang blok di dalam N kali',
    },
    {
      type: 'loop_forever',
      message0: '🔂 selamanya',
      message1: '%1',
      args1: [{ type: 'input_statement', name: 'DO' }],
      previousStatement: null,
      nextStatement: null,
      colour: 20,
      tooltip: 'Ulang terus sampai game berhenti',
    },
    {
      type: 'loop_wait',
      message0: '⏸️ tunggu %1 detik',
      args0: [
        { type: 'field_number', name: 'SECONDS', value: 1, min: 0.1, max: 30, precision: 0.1 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: 20,
      tooltip: 'Tunggu N detik sebelum lanjut',
    },
    {
      type: 'loop_wait_until',
      message0: '🚦 tunggu sampai %1',
      args0: [{ type: 'input_value', name: 'COND', check: 'Boolean' }],
      previousStatement: null,
      nextStatement: null,
      colour: 20,
      tooltip: 'Tunggu sampai kondisi benar',
    },
  ])
}
